import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useNavigate } from "react-router-dom";
import { useWindowSize } from "../hooks/useWindowSize";
// import Logo from '../../assets/images/logo_esimerkki.png';
import Logo from "../../assets/images/Munhuolto_logo_teksti.svg";
import "../styles/style.css";
import Language from "./Language";
import LoginPopup from "./LoginPopup";
import { Divider, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { clearCredentials, userInfo } from "../../app/store/authSlice";
import UserProfileChip from "./UserProfileChip";
import { useLogoutMutation } from "../../app/store/api/authApi";
import toast from "react-hot-toast";
import LogoutIcon from "@mui/icons-material/Logout";
import LoginIcon from "@mui/icons-material/Login";
import PersonIcon from "@mui/icons-material/Person";
import { useTranslation } from "react-i18next";
import { getRouteForUser } from "../utils/roleRoutes";

const ITEM_HEIGHT = 48;

export default function TopBar() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { isDesktop } = useWindowSize();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const userDetails = useSelector(userInfo);
  const dispatch = useDispatch();
  const [logout] = useLogoutMutation();
  const isLoggedIn = Boolean(userDetails);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    try {
      await toast.promise(logout().unwrap(), {
        loading: t("login.logoutLoading"),
        success: t("login.logoutSuccess"),
        error: t("login.logoutError"),
      });
    } catch (err) {
      console.error(t("login.logoutError"), err);
    } finally {
      dispatch(clearCredentials());
    }
  };

  const handleLoginClick = () => {
    setShowLoginPopup(true);
  };

  const handleDashboardClick = () => {
    navigate(getRouteForUser(userDetails), { replace: true });
    handleClose();
  };

  const handleOptionClick = async (option) => {
    option.onclick();
    handleClose();
  };

  const addRoleBasedOption = () => {
    if (userDetails) {
      if (userDetails.groups.includes("admin")) {
        return { text: t("authorized.adminDashboard"), icon: <PersonIcon fontSize='small' />, onclick: handleDashboardClick };
      } else {
        return { text: t("authorized.userDashboard"), icon: <PersonIcon fontSize='small' />, onclick: handleDashboardClick };
      }
    }
    else{
        return null;
    }
  };

  const options = isLoggedIn ? [addRoleBasedOption(), { text: "Logout", icon: <LogoutIcon fontSize='small' />, onclick: handleLogout }] : [{ text: "Login", icon: <LoginIcon fontSize='small' />, onclick: handleLoginClick }];

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position='static' color='transparent' sx={{ boxShadow: "none", backgroundColor: "transparent" }}>
        <Toolbar>
          <Typography variant='h6' component='div' sx={{ flexGrow: 1 }}>
            <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "flex-start" }} onClick={() => navigate("/")}>
              <img className='logo' src={Logo} alt='Logo' />
            </Box>
          </Typography>
          {isDesktop ? (
            <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
              <Link to='/' style={{ color: "inherit", textDecoration: "none" }}>
                Huoltamot
              </Link>
              <Link to='/about' style={{ color: "inherit", textDecoration: "none" }}>
                Palvelut
              </Link>
              <Link to='/contact' style={{ color: "inherit", textDecoration: "none" }}>
                Meistä
              </Link>
              <Link to='/contact' style={{ color: "inherit", textDecoration: "none" }}>
                Ota yhteyttä
              </Link>
              {isLoggedIn ? <UserProfileChip /> : <LoginPopup viewType='desktop' openPopup={showLoginPopup} onClosePopup={() => setShowLoginPopup(false)} />}
              <Box sx={{ ml: 1, display: "flex", alignItems: "center" }}>
                <Language />
              </Box>
            </Box>
          ) : (
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <Language />
              <IconButton size='large' color='inherit' aria-label='menu' aria-controls={open ? "long-menu" : undefined} aria-expanded={open} aria-haspopup='true' onClick={handleClick}>
                <MenuIcon />
              </IconButton>
              <Menu
                id='long-menu'
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                  paper: {
                    style: {
                      maxHeight: ITEM_HEIGHT * 4.5,
                      width: isLoggedIn ? "250px" : "150px",
                    },
                  },
                  list: {
                    "aria-labelledby": "long-button",
                  },
                }}
              >
                {isLoggedIn && (
                  <>
                    <MenuItem disabled sx={{ opacity: 1, cursor: "default" }}>
                      <Box sx={{}}>
                        <Typography variant='caption' color='text.secondary'>
                          Signed in as
                        </Typography>
                        <Typography variant='body2' sx={{ wordBreak: "break-all", fontSize: "10px", color: "black", fontWeight: 500 }}>
                          {userDetails.email}
                        </Typography>
                      </Box>
                    </MenuItem>
                    <Divider />
                  </>
                )}
                {options.map((option) => (
                  <MenuItem key={option.text} selected={option === "Login"} onClick={() => handleOptionClick(option)}>
                    <ListItemIcon>{option.icon}</ListItemIcon>
                    <ListItemText primary={option.text} />
                  </MenuItem>
                ))}
              </Menu>

              {showLoginPopup && <LoginPopup viewType='mobile' openPopup={showLoginPopup} onClosePopup={() => setShowLoginPopup(false)} />}
            </Box>
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
}
